import { createIcon } from '@chakra-ui/icon';
export var StarIcon = createIcon({
  displayName: 'StarIcon',
  d: 'M10 0l2.245 6.91h7.266l-5.878 4.27 2.245 6.91L10 13.82l-5.878 4.27 2.245-6.91L.49 6.91h7.266L10 0z'
});
//# sourceMappingURL=Star.js.map